var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-component",class:{obtained : _vm.obtained}},[_c('img',{ref:"badge-icon",staticClass:"badge-component-image",attrs:{"src":_vm.badge.imageUrl,"alt":"badge icon"},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }